import * as React from "react"
import { cn } from "../../lib/utils"

// Modify Input component to solve focus issues
const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  // Create our own ref if one isn't provided
  const inputRef = React.useRef(null);
  
  // Use the provided ref or our local one
  const combinedRef = ref || inputRef;
  
  // Focus preservation logic
  const [hasFocus, setHasFocus] = React.useState(false);
  
  React.useEffect(() => {
    // If the input should have focus but doesn't, restore it
    if (hasFocus && combinedRef.current && document.activeElement !== combinedRef.current) {
      combinedRef.current.focus();
    }
  });

  return (
    <input
      type={type}
      className={cn(
        // Base styles
        "flex h-10 w-full rounded-md border px-3 py-2 text-sm ring-offset-background",
        "file:border-0 file:bg-transparent file:text-sm file:font-medium",
        "placeholder:text-muted-foreground",
        "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2",
        "disabled:cursor-not-allowed disabled:opacity-50",
        // Theme-aware background and border defaults
        "bg-background border-input text-foreground",
        // Theme-aware hover - this is the key fix
        "hover:bg-accent/10 hover:border-accent-foreground/20",
        className
      )}
      ref={combinedRef}
      onFocus={() => setHasFocus(true)}
      onBlur={() => setHasFocus(false)}
      {...props}
    />
  )
})
Input.displayName = "Input"

export { Input }